window.BEAEPAGEJS = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-nrro0kc8section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nrro0kc8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nrro0kc8');
        args.el = args.els[0];
        ((t) => { var o;if(new ResizeObserver(a=>{window.requestAnimationFrame(()=>{let s=t.el.querySelector(".beae__section--container .beae-grid-system")?t.el.querySelector(".beae__section--container .beae-grid-system"):t.el.querySelector(".beae__section--container");if(!s)return;let n=getComputedStyle(s).maxWidth,r=parseFloat(n.replace(/[^\d\.]*/g,"")),l=window.innerWidth;(!r||n==="100%")&&(r=1920);let c=l>768?s.offsetWidth/r<1?((s.offsetWidth-r)*1+r)/r:1:((l-428)*1+428)/428;t.el.style.setProperty("--scale-ratio",c.toString())})}).observe(t.el),(o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nrro0kc8: ', ex)
      };
    

      try {
        let argid = 'beae-xtdbvs4wblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xtdbvs4w',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xtdbvs4w');
        args.el = args.els[0];
        ((r) => { const p=window.location.href.indexOf("contact_posted=true")!==-1,u=r.el.querySelector("form");r.el.querySelector(".beae-btn-pr");const b=r.el.querySelectorAll("input","select","button","textarea","checkbox","radio");!p&&r.mode.value!=="builder"&&(r.el.querySelector(".beae-form-success-message").style="display: none");const m=[];u&&u.addEventListener("submit",f=>{f.preventDefault();for(let _=0;_<b.length;_++)m.push({fieldKey:b[_].name,fieldType:b[_].type,fieldValue:b[_].value})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xtdbvs4w: ', ex)
      };
    }; if (window.BEAEBASE) {window.BEAEPAGEJS()} 